
import { Component, OnInit } from '@angular/core';
import { IndexService } from '../../../services/index.service';
import { HttpService } from '../../../../core/services/http.service';
import { TranslateService } from '@ngx-translate/core';
import { PreferencesService } from '../../../../core/services/preferences.service';
import { MetaDataService } from '../../../../core/services/meta-data.service';
import { StorageService } from '../../../../core/services/storage.service';


@Component({
    selector: 'app-index',
    templateUrl: './index.component.html',
    styleUrls: ['./index.component.css']
})
export class IndexComponent implements OnInit {

    constructor(
        public index: IndexService,
        private translate: TranslateService,
        private preferences: PreferencesService,
        private http: HttpService,
        private meta: MetaDataService,
        private storage: StorageService
    ) {

        translate.addLangs(['zh-CN', 'zh-TW', 'en-US']);
        // this language will be used as a fallback when a translation isn't found in the current language
        translate.setDefaultLang('zh-CN');

        this.preferences.get('lang', true).then((value) => {
            // the lang to use, if the lang isn't available, it will use the current loader to get them
            translate.use(value || 'zh-CN');
        });
    }

    get loading() {
        return this.index.loading$;
        // return this.http.loading$;
        // .do(x => { console.log(x); });
        // .distinctUntilChanged();
    }

    ngOnInit() {
        this.meta.init();
        this.storage.init();
    }

}



// WEBPACK FOOTER //
// F:/WMS/X-xiamenzhuhe-SDM234/zhuhe-234/sdm_fe/src/app/home/components/system/index/index.component.ts